import { HStack } from '@musinsa/mwms-ds'
import Text from '@/components/content/Text'
import SelectBox from '@/components/content/SelectBox_new'
import styled from 'styled-components'
import { colorSystem } from '@/styles/theme'
import { SelectOptionType } from '@/components/content/SelectBoxTypes'

type Props = {
  type: 'ALLOCATION' | 'OVERSEAS'
  warehouseOptions: SelectOptionType<string>[]
  warehouseCodes?: (string | undefined)[]
  onWarehouseChange: (idx: number, warehouseCodes: string | undefined) => void
}

export function PrioritySelectors({ warehouseOptions, type, warehouseCodes, onWarehouseChange }: Props) {
  const selectLength = type === 'ALLOCATION' ? 5 : 3

  const handleChange = (idx: number, value: string | undefined) => {
    const selectedIdx = warehouseCodes?.findIndex((code) => code === value)

    onWarehouseChange(idx, value)

    if (selectedIdx === -1 || !selectedIdx) {
      return
    }

    for (let i = selectedIdx; i < selectLength; i++) {
      onWarehouseChange(i, undefined)
    }
  }

  return (
    <>
      {Array.from({ length: selectLength }).map((_, idx) => {
        const isDisabled = idx > 0 && !warehouseCodes?.[idx - 1]

        // 앞의 순위에서 선택한 옵션은 비노출
        const selectedWarehouseCodes = warehouseCodes || []
        const previousSelectedCodes = selectedWarehouseCodes.slice(0, idx)
        const filteredOptions = warehouseOptions.filter((option) => !previousSelectedCodes.includes(option.value))

        const value = warehouseCodes?.[idx]
        const isValidValue = filteredOptions.some((option) => option.value === value)

        return (
          <HStack justify="space-between">
            {idx === 0 ? <RequiredText kind="Body_14_medium">{idx + 1}순위</RequiredText> : <Text kind="Body_14_medium">{idx + 1}순위</Text>}
            <div style={{ width: 260 }}>
              <SelectBox
                block
                disabled={isDisabled}
                options={filteredOptions}
                placeholder={isDisabled ? '우선순위에 맞춰 센터를 선택해 주세요.' : `${idx + 1}순위 센터를 선택해 주세요.`}
                value={isValidValue ? value : undefined}
                onChange={(value) => handleChange(idx, value)}
                onClear={warehouseCodes?.[idx + 1] === undefined ? () => handleChange(idx, undefined) : undefined}
              />
            </div>
          </HStack>
        )
      })}
    </>
  )
}

const RequiredText = styled(Text)`
  &:after {
    content: '*';
    display: inline-block;
    margin-left: 2px;
    padding-top: 6px;
    color: ${colorSystem.text.common.highlight};
  }
`
